@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package orecompose.gallery.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainFont0 {
  public val HarmonyOS_Sans_SC_Regular: FontResource by 
      lazy { init_HarmonyOS_Sans_SC_Regular() }
}

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("HarmonyOS_Sans_SC_Regular", CommonMainFont0.HarmonyOS_Sans_SC_Regular)
}

internal val Res.font.HarmonyOS_Sans_SC_Regular: FontResource
  get() = CommonMainFont0.HarmonyOS_Sans_SC_Regular

private fun init_HarmonyOS_Sans_SC_Regular(): FontResource =
    org.jetbrains.compose.resources.FontResource(
  "font:HarmonyOS_Sans_SC_Regular",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/orecompose.gallery.generated.resources/font/HarmonyOS_Sans_SC_Regular.ttf", -1, -1),
    )
)
